// material-ui

import sendobcmsgicon from '../../../assets/images/send-msg.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const SendObcMsgIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={sendobcmsgicon} alt="Send Message to OBC" width="22"  />
    );
};

export default SendObcMsgIcon;